import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Guards /mindyourmusic: if user has pending admission for an active show,
 * redirect to lobby. Otherwise render children.
 */
const ShowTimeMymGuard = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthContext();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setChecking(false);
      return;
    }
    let cancelled = false;
    const token = localStorage.getItem('auth_token');
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    fetch(`${API_BASE}/api/show-times/can-access-mym`, { headers })
      .then(async (res) => {
        try {
          const data = await res.json();
          if (!res.ok || !data || typeof data !== 'object') {
            return { canAccess: true };
          }
          return data;
        } catch {
          return { canAccess: true };
        }
      })
      .then((data) => {
        if (cancelled) return;
        if (!data.canAccess && data.redirectTo) {
          navigate(data.redirectTo, { replace: true, state: { from: 'mym', reason: data.reason } });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setChecking(false);
        }
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });
    return () => { cancelled = true; };
  }, [isAuthenticated, user, navigate]);

  if (isAuthenticated && user && checking) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress sx={{ color: '#FF6B9D' }} />
      </Box>
    );
  }
  return <>{children}</>;
};

export default ShowTimeMymGuard;
